import Vue from 'vue'
import VueRouter from 'vue-router'
//import store from '@/config/store.js'


Vue.use(VueRouter)

const routes = [
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    name: 'LogIn',
    component: () => import('@/views/LogIn.vue'),
  }, 
  {
    path: '/registration',
    name: 'Registration',
    component: () => import('@/views/Registration.vue'),
  },
  {
    path: '/emailverification/:token',
    name: 'Verification',
    component: () => import('@/views/Verification.vue'),
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/forgotten_password/:token',
    name: 'NewPassword',
    component: () => import('@/views/NewPassword.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  }, 
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('@/views/Accounts.vue'),
    meta: {
      requiresAuth: true
    }
  }, 
  {
    path: '/activate/:token',
    name: 'Activate',
    component: () => import('@/views/Activate.vue'),
    meta: {
      requiresAuth: false
    }
  }, 
  {
    path: '/client/:client_slug',
    name: 'Client',
    component: () => import('@/views/Client.vue'), 
    meta: {
      requiresAuth: true
    }  
  },
  
  {
    path: '/brand/:brand_slug',
    name: 'Brand',
    component: () => import('@/views/Brand.vue'),
    meta: {
      requiresAuth: true
    }
  },   
  {
    path: '/brand/:brand_slug/:campaign_slug/:board_slug',
    name: 'BrandBoard',
    component: () => import('@/views/Brand.vue'),
    meta: {
      requiresAuth: true
    }
  },   
  {
    path: '/board/:board_slug',
    name: 'Board',
    component: () => import('@/views/Board.vue'),
  },   
  {
    path: '/board/:board_slug/:creative_idx',
    name: 'BoardCreative',
    component: () => import('@/views/Board.vue'),
  },   
  {
    path: '/404',
    name: '404-page',          
    component: () => import('@/views/PageNotFound.vue'),    
  },   
  {
    // 404 page
    path: "*",
    redirect: '404'         
  } 
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
